/**
 * Display options for the company/client logo on the impact overview chart.
 * UI-only state: the choice is not persisted.
 */
export type ChartLogoPosition = 'none' | 'center' | 'side';

/** A selectable logo source (the trip's company or one of its client companies). */
export interface ChartLogoSource {
  /** 'company' for the trip's own company, otherwise the CompanyClient id. */
  id: string;
  name: string;
  logoUrl: string;
}

/** Trip company summary returned by the detailed impact report endpoint. */
export interface ImpactReportCompany {
  id: string;
  name: string;
  logoUrl?: string | null;
}

/**
 * Selectable logo sources for a trip: its own company first, then the client
 * companies that have a logo. Shared by the chart controls and the PDF export dialog.
 */
export function buildChartLogoSources(
  company: ImpactReportCompany | null,
  clients: { id: string; name: string; logoUrl?: string | null }[],
): ChartLogoSource[] {
  const sources: ChartLogoSource[] = [];
  if (company?.logoUrl) {
    sources.push({ id: 'company', name: company.name, logoUrl: company.logoUrl });
  }
  for (const client of clients) {
    if (client.logoUrl) {
      sources.push({ id: client.id, name: client.name, logoUrl: client.logoUrl });
    }
  }
  return sources;
}
